export const BudgetRoutes = {
    OVERVIEW: '/budget',
    SCENARIOS: '/budget/scenarios',
    // Full-page "Neues Szenario anlegen" (the board's create screen), mirroring /forecasts/new.
    SCENARIO_NEW: '/budget/scenarios/new',
    // CALL-765: consolidated what-if view across selected scenarios (Konsolidierte Ansicht).
    SCENARIOS_CONSOLIDATED: '/budget/scenarios/consolidated',
    BILLING_CONFIG: '/budget/billing-config',
    WORKING_UNIT_MAPPING: '/budget/working-unit-mapping',
    PRICES_ABT: '/budget/prices-abt',
} as const;

// Detail/input page for a single scenario (CALL-763).
export const budgetScenarioDetailRoute = (scenarioId: number | string) => `/budget/scenarios/${scenarioId}`;
